import React, { Component } from 'react';
import './Research.css';

class Research extends Component {
  render() {
    return (
      <div>
        <br />
        <div style={{ fontSize: "32px", fontWeight: "bold" }}>
          <p>Expertise and Research Filds</p>
        </div>


        {/* Embedded Systems */}
        <div className="card border-dark mb-3">
          <div className="card-header" style={{ backgroundColor: "#aaffaa" }}>
            <h2><span className="fa fa-microchip fa-lg"></span>Embedded Systems and Electronics</h2>
          </div>
          <div className="card-body" style={{ paddingBottom: "0"}}>
            <h5 className="card-title" style={{ marginLeft: "26px" }}>Robust and High-Precision of Electronic and Embedded Systems for Real-World Applications</h5>
            <table className="table table-sm">
              <tbody>
                <tr className="">
                  <td><span className="fa fa-microchip fa-sm"></span>Embedded Real-time Operating Systems and Real-Time Systems</td>
                </tr>
                <tr className="">
                  <td><span className="fa fa-microchip fa-sm"></span>Embedded Software, OS, Firmware and Driver</td>
                </tr>
                <tr className="">
                  <td><span className="fa fa-microchip fa-sm"></span>Embedded Hardware, Electronic Circuits, both Digital and Analog</td>
                </tr>
                <tr className="">
                  <td><span className="fa fa-microchip fa-sm"></span>Robust and High Precision Equipment and Other Devices</td>
                </tr>
                <tr className="">
                  <td><span className="fa fa-microchip fa-sm"></span>IoT Devices for Real-time Monitoring and Control Applications</td>
                </tr>
                <tr className="">
                  <td><span className="fa fa-microchip fa-sm"></span>Hardware-in-the-loop for Real-time Monitoring and Control Systems</td>
                </tr></tbody>
            </table>
          </div>
        </div>


        <br />
        {/* Digital Signal Processing */}
        <div className="card border-dark mb-3">
          <div className="card-header" style={{ backgroundColor: "#ffffaa" }}>
            <h2><span className="fa fa-bar-chart fa-lg"></span>Digital Signal Processing and Artificial Intelligence</h2>
          </div>
          <div className="card-body" style={{ paddingBottom: "0" }}>
            <h5 className="card-title" style={{ marginLeft: "26px" }}>Industrial Applications of the Digital Signal Processing, Speech Processing, Image Processing and Artificial Intelligence</h5>
            <table className="table table-sm">
              <tbody>
                <tr className="">
                  <td><span className="fa fa-bar-chart fa-sm"></span>Speech Signal Processing, Speech Recognition and Speaker Recogntion</td>
                </tr>
                <tr className="">
                  <td><span className="fa fa-bar-chart fa-sm"></span>Speech Signal Synthesis and Speech Signal Enhancement</td>
                </tr>
                <tr className="">
                  <td><span className="fa fa-bar-chart fa-sm"></span>Image Processing and Computer Vision</td>
                </tr>
                <tr className="">
                  <td><span className="fa fa-bar-chart fa-sm"></span>Machine Learning, Pattern Recognition</td>
                </tr>
                <tr className="">
                  <td><span className="fa fa-bar-chart fa-sm"></span>Software Design and Development for Computer Intelligence Systems</td>
                </tr></tbody>
            </table>
          </div>
        </div>

        <br />
        {/* Industrial Automation and Power Electronics */}
        <div className="card border-dark mb-3">
          <div className="card-header" style={{ backgroundColor: "#aaaaff" }}>
            <h2><span className="fa fa-cogs fa-lg"></span>Industrial Automation and Power Electronics</h2>
          </div>
          <div className="card-body" style={{ paddingBottom: "0" }}>
            <h5 className="card-title" style={{ marginLeft: "26px" }}>System Design and Implementation/Integration of Industrial Automation Systems and Power Electronics for Industrial Applications</h5>
            <table className="table table-sm">
              <tbody>
                <tr className="">
                  <td><span className="fa fa-cogs fa-sm"></span>Embedded Digital Controller for Power Elctronic and Automation Applications</td>
                </tr>
                <tr className="">
                  <td><span className="fa fa-cogs fa-sm"></span>Microcontroller and Computer Controlled for Automation Systems</td>
                </tr>
                <tr className="">
                  <td><span className="fa fa-cogs fa-sm"></span>Real-time Computer-based Monitoring and Control for Industrial Applications</td>
                </tr>
                <tr className="">
                  <td><span className="fa fa-cogs fa-sm"></span>Robus and High-Precision Digital Power Converter and Digital Power Supply</td>
                </tr>
                <tr className="">
                  <td><span className="fa fa-cogs fa-sm"></span>Robus and High-Precision Digital Motor Controller and High-Power Motor Driver</td>
                </tr>
                <tr className="">
                  <td><span className="fa fa-cogs fa-sm"></span>Machine Design, Simulation and Control for Industrial Automation Applications</td>
                </tr>
                <tr className="">
                  <td><span className="fa fa-cogs fa-sm"></span>Hardware-in-the-loop for System Dynamics and Power Electronics</td>
                </tr>
                <tr className="">
                  <td><span className="fa fa-cogs fa-sm"></span>System Dynamics Modeling and Control for Power Electronic and Automation Systems</td>
                </tr></tbody>
            </table>
          </div>
        </div>


        <br />
        {/* Internet-of-Things and Computer Technologies */}
        <div className="card border-dark mb-3">
          <div className="card-header" style={{ backgroundColor: "#aaffff" }}>
            <h2><span className="fa fa-wifi fa-lg"></span>Internet-of-Things and Computer Technologies</h2>
          </div>
          <div className="card-body" style={{ paddingBottom: "0" }}>
            <h5 className="card-title" style={{ marginLeft: "26px" }}>New and Popular Technologies relatted to Internet-of-Things, Industrial 4.0 and Other Computer Technologies</h5>
            <table className="table table-sm">
              <tbody>
                <tr className="">
                  <td><span className="fa fa-wifi fa-sm"></span>IoT Platform and Frameworks (Hardware, Software, Services) Design and Development</td>
                </tr>
                <tr className="">
                  <td><span className="fa fa-wifi fa-sm"></span>IoT Devices and IoT Gateway Design and Development</td>
                </tr>
                <tr className="">
                  <td><span className="fa fa-wifi fa-sm"></span>Sensor Nodes and Sensor Networks for Real-time Monitor and Control Applications</td>
                </tr>
                <tr className="">
                  <td><span className="fa fa-wifi fa-sm"></span>Smart Home, Smart Farming, Smart Factory, and Other Smart Systems</td>
                </tr>
                <tr className="">
                  <td><span className="fa fa-wifi fa-sm"></span>Embedded Computing, Edge Computing and Cloud Computing for Real-World Applications</td>
                </tr>
                <tr className="">
                  <td><span className="fa fa-wifi fa-sm"></span>Front-End and Back-End Software Design and Implememtation based on Mobile, Web and Computer (Cross Platform)</td>
                </tr></tbody>
            </table>
          </div>
        </div>

        <br />
        {/* 2D and 3D Computer Graphics, 3D Modeling and Game Development */}
        <div className="card border-dark mb-3">
          <div className="card-header" style={{ backgroundColor: "#ffaaff" }}>
            <h2><span className="fa fa-star-half-o fa-lg"></span>Computer Graphics, 3D Modeling and Game Development</h2>
          </div>
          <div className="card-body" style={{ paddingBottom: "0" }}>
            <h5 className="card-title" style={{ marginLeft: "26px" }}>Computer Graphics for Modeling, Visualization and Game Creation</h5>
            <table className="table table-sm">
              <tbody>
                <tr className="">
                  <td><span className="fa fa-star-half-o fa-sm"></span>OpenGL, WebGL and Other Graphics Libraries for Computer Graphics</td>
                </tr>
                <tr className="">
                  <td><span className="fa fa-star-half-o fa-sm"></span>Vertext/Poly-based and Sculpting-based Modeling</td>
                </tr>
                <tr className="">
                  <td><span className="fa fa-star-half-o fa-sm"></span>Physically-Based Rendering (PBR) for Realistic Visualization</td>
                </tr>
                <tr className="">
                  <td><span className="fa fa-star-half-o fa-sm"></span>Character and Other Objects Modeling for Game Engines/Game Creation</td>
                </tr>
                <tr className="">
                  <td><span className="fa fa-star-half-o fa-sm"></span>Game Design and Game Programming based on C++, C# and many Others</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* END CARD */}
      </div>
    );
  }
}

export default Research;
